import React from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import DataTable from "../../components/Elements/DataTable/DataTable";

import { fetchTransactionsAdmin } from "../../services/TransactionService";

// Always visible transaction columns
const alwaysVisibleColumns = [
  { key: "id", label: "Transaction ID", width: "320px" },
  { key: "wallet_id", label: "Wallet ID", width: "320px" },
  { key: "user_id", label: "User ID", width: "300px" },
  { key: "amount", label: "Amount", width: "300px" },
  { key: "transaction_type", label: "Type", width: "140px" },
  { key: "success", label: "Success", width: "140px" },
  { key: "payment.provider", label: "Provider", width: "140px" },
  { key: "date", label: "Date", width: "300px" },
  { key: "name", label: "Name", width: "300px" },
  { key: "related_esim.status", label: "Status", width: "140px" },
  { key: "related_esim.installed", label: "Installed", width: "140px" },
];

// Optional columns that can be toggled
const optionalColumns = [
  { key: "payment.status", label: "Payment Status", width: "140px" },
  { key: "promocode_code", label: "Promocode", width: "140px" },
  { key: "payment.external_id", label: "External ID", width: "300px" },
  { key: "related_transaction_id", label: "Related Transaction ID", width: "300px" },
  { key: "related_esim.iccid", label: "ICCID", width: "180px" },
  { key: "related_esim.data_limit", label: "Data Limit", width: "300px" },
  { key: "related_esim.country_name", label: "Country", width: "140px" },
];

// Sort options
const sortOptions = [
  { value: "transaction.date", label: "Date" },
  { value: "transaction.amount", label: "Amount" },
  { value: "transaction.transaction_type", label: "Type" },
  { value: "transaction.user_id", label: "User ID" },
  { value: "transaction.wallet_id", label: "Wallet ID" },
  { value: "transaction.id", label: "Transaction ID" },
  { value: "transaction.success", label: "Success" },
  { value: "payment.provider", label: "Provider" },
  { value: "payment.status", label: "Payment Status" },
];

// Filters
const filterDefinitions = [
  { key: "user_id", label: "User ID", type: "text" },
  { key: "payment.provider", label: "Provider", type: "text" },
  { key: "wallet_id", label: "Wallet ID", type: "text" },
  { key: "external_transaction_id", label: "Ext Transaction ID", type: "text" },
  { key: "amount", label: "Amount", type: "minmax", inputType: "number" },
  { key: "currency", label: "Currency", type: "text" },
  {
    key: "id",
    filterKey: "transaction_id",
    label: "Transaction ID",
    type: "text",
  },
  {
    key: "transaction_type",
    filterKey: "type",
    label: "Type",
    type: "select",
    options: [
      { value: "topup", label: "Top-Up" },
      { value: "service", label: "Service" },
      { value: "api", label: "API" },
      { value: "transfer", label: "Transfer" },
      { value: "invoice", label: "Invoice" },
    ],
  },
  {
    key: "success",
    label: "Success",
    type: "select",
    options: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ],
  },
  {
    key: "date",
    label: "Date",
    type: "date-range",
    minKey: "date_from",
    maxKey: "date_to",
  },
];

// Custom cell renderers
const customRenderers = {
  success: (item) => (
    <span className={item.success ? "badge-active" : "badge-inactive"}>{item.success ? "Yes" : "No"}</span>
  ),
  date: (item) => {
    if (!item.date) return "-";
    return new Date(item.date).toLocaleString("pl-PL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  },
  amount: (item) => `${item.amount?.toFixed(2) || 0} ${item.currency || ""}`,
};

export default function AdminTransactions() {
  return (
    <main className="admin-transactions-page">
      <PageHeader title="Transactions" description="View and manage all user transactions" />

      <DataTable
        tableId="admin-transactions"
        fetchDataFunction={fetchTransactionsAdmin}
        columns={alwaysVisibleColumns}
        optionalColumns={optionalColumns}
        sortOptions={sortOptions}
        filterDefinitions={filterDefinitions}
        defaultSortBy="transaction.date"
        itemKey="id"
        customRenderers={customRenderers}
        showCheckboxes={false}
      />
    </main>
  );
}
